<div id="blog" class="blog-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h4>{{ 'representations.kicker' | translate }}</h4>
            <h2>{{ 'representations.title' | translate }}<span></span></h2>

        </div>
        <div class="blog-slides">
            @if (languageService.currentLang(); as lang) {
            <owl-carousel-o [options]="blogSlides">
                <ng-template carouselSlide>
                    <div class="single-blog-item bg1">
                        <span>{{ 'representations.spain' | translate }}</span>
                        <h3><a href="https://www.lumiartecnia.com/es/" target="_blank">Luminotecnia Internacional</a></h3>
                        <p>{{ 'representations.lumiartecnia' | translate }}</p>
                        <a href="https://www.lumiartecnia.com/es/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg2">
                        <span>{{ 'representations.spain' | translate }}</span>
                        <h3><a href="https://www.aruservicios.com/" target="_blank">Aru Servicios</a></h3>
                        <p>{{ 'representations.aru' | translate }}</p>
                        <a href="https://www.aruservicios.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg3">
                        <span>{{ 'representations.china' | translate }}</span>
                        <h3><a href="https://www.neo-neon.com/" target="_blank">Neo Neon/CRled/MediaFade</a></h3>
                        <p>{{ 'representations.neoNeon' | translate }}</p>
                        <a href="https://www.neo-neon.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.germany' | translate }}</span>
                        <h3><a href="https://www.wieland-electric.com/en/" target="_blank">Wieland Electric</a></h3>
                        <p>{{ 'representations.wieland' | translate }}</p>
                        <a href="https://www.wieland-electric.com/en/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.veCr' | translate }}</span>
                        <h3><a href="http://grupoisotex.com/" target="_blank">ISOPanel (Grupo Isotex)</a></h3>
                        <p>{{ 'representations.isopanel' | translate }}</p>
                        <a href="http://grupoisotex.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.colombia' | translate }}</span>
                        <h3><a href="https://www.tantuxdistanciadores.com/" target="_blank">Tantux</a></h3>
                        <p>{{ 'representations.tantux' | translate }}</p>
                        <a href="https://www.tantuxdistanciadores.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.spain' | translate }}</span>
                        <h3><a href="https://www.keiken-engineering.com/" target="_blank">Keiken Engineering</a></h3>
                        <p>{{ 'representations.keiken' | translate }}</p>
                        <a href="https://www.keiken-engineering.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.vePeMxUs' | translate }}</span>
                        <h3><a href="https://ekabel.net/es/home-es/" target="_blank">Ekabel</a></h3>
                        <p>{{ 'representations.ekabel' | translate }}</p>
                        <a href="https://ekabel.net/es/home-es/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.venezuela' | translate }}</span>
                        <h3><a href="https://recologica.com/" target="_blank">Recologica</a></h3>
                        <p>{{ 'representations.recologica' | translate }}</p>
                        <a href="https://recologica.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.czech' | translate }}</span>
                        <h3><a href="https://www.preciosalighting.com/" target="_blank">Preciosa Lighting</a></h3>
                        <p>{{ 'representations.preciosa' | translate }}</p>
                        <a href="https://www.preciosalighting.com/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.spain' | translate }}</span>
                        <h3><a href="https://www.uniarte.es/" target="_blank">Uniarte</a></h3>
                        <p>{{ 'representations.uniarte' | translate }}</p>
                        <a href="https://www.uniarte.es/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
                <ng-template carouselSlide>
                    <div class="single-blog-item bg5">
                        <span>{{ 'representations.spain' | translate }}</span>
                        <h3><a href="http://www.ades.tv/" target="_blank">ADES</a></h3>
                        <p>{{ 'representations.ades' | translate }}</p>
                        <a href="http://www.ades.tv/" target="_blank" [attr.title]="'welcome.readMore' | translate" class="link-btn"><i class="fa-solid fa-handshake-simple"></i></a>
                    </div>
                </ng-template>
            </owl-carousel-o>
            }
        </div>
    </div>
</div>
